import React from "react"
import { motion } from "framer-motion"
import { X } from "lucide-react"
import { PINNED_MSG } from "./constants"

const PinnedMessage = ({ onClose }) => (
  <motion.div
    initial={{ height: 0, opacity: 0 }}
    animate={{ height: "auto", opacity: 1 }}
    exit={{ height: 0, opacity: 0 }}
    transition={{ duration: 0.2 }}
    className="overflow-hidden flex-shrink-0"
  >
    <div className="px-4 py-3 bg-white border-b border-slate-200 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="w-1 self-stretch bg-blue-500 rounded-full flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-blue-600 mb-0.5">Pinned message</p>
          <p className="text-sm text-slate-700 line-clamp-1">{PINNED_MSG}</p>
        </div>
        <button
          onClick={onClose}
          className="p-1.5 hover:bg-slate-100 rounded-full transition-colors flex-shrink-0"
        >
          <X className="w-4 h-4 text-blue-600" />
        </button>
      </div>
    </div>
  </motion.div>
)

export default PinnedMessage
